import { RelationSizeParams } from '../'
import { branch } from '../constants'

module.exports = () ->
  { className } = RelationSizeParams
  configNode = new Weaver.Node(className)
  configNode.set('name', className)
  await configNode.save({ branch, commitMessage: "Add Relation Size Params Migration." })
  relationSizeParams = new RelationSizeParams()
  await relationSizeParams.reset()
